// @ts-nocheck
import React from 'react';
import { Box, Button, CircularProgress, Grid, InputLabel, TextField, Typography } from '@mui/material';
import { CustomInput } from '../../../components/Custom/Input';
import styles from '../../create-event/components/event-information/eventInformation.module.css';

// utils
import PropTypes from 'prop-types';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { setTimeToZero } from '../../../utils/methods/dateAndTimeMethods';
import dayjs from 'dayjs';
import { CustomDatePicker } from '../../../components/Custom/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { updateEventInfomationAction } from '../../../store/actions/eventRequest';
import { alertDialogAciton } from '../../../store/actions/auth';
import { addEditLogAction } from '../../../store/actions/logs';
import AddressAutocomplete from '../../../components/Custom/react-google-maps/AddressAutoComplete';
import { eventEditedAfterEstimateAction } from '../../../store/actions/eventRequestDetails';
import { USER_ROLES } from '../../../staticData/userRoles';
import { isUserRole } from '../../../utils/methods/storeFunc';

export default function EditEventTab({ eventData, handleClose, updateEvent }) {
  const libraries = React.useMemo(() => {
    return ['places'];
  }, []);

  const [oldData, setOldData] = React.useState({});
  const googleMapsPackage = useSelector((store) => store.googleMapsPackage);
  const { ucLoading } = useSelector((state) => state.eventRequest);
  const { userId } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  const formSchema = React.useMemo(() => {
    return Yup.object().shape({
      eventName: Yup.string()
        .trim()
        .max(255, 'Event Name should have at most 255 characters!')
        .required('Event name required'),
      eventStart: Yup.string()
        .test(
          'should-be-greater-than-or-equal-to-current-date-or-created-value',
          'Event start should be greater than or equal to current date or created value',
          function (code) {
            if (!this.parent.eventStart) {
              return true;
            }

            if (eventData?.eventStart) {
              let eventStartDate = new Date(this.parent.eventStart);
              let currentDate = new Date();
              let eventInfoStartDate = new Date(eventData?.eventStart);

              eventStartDate = setTimeToZero(eventStartDate);
              currentDate = setTimeToZero(currentDate);
              eventInfoStartDate = setTimeToZero(eventInfoStartDate);

              let comparator;

              if (currentDate <= eventInfoStartDate) comparator = currentDate;
              else comparator = eventInfoStartDate;

              return !isUserRole(
                USER_ROLES.ADMIN,
                USER_ROLES.SUPERADMIN,
                USER_ROLES.CLIENT,
                USER_ROLES.COORDINATOR,
              )
                ? eventStartDate >= comparator
                : true;
            } else {
              let eventStartDate = new Date(this.parent.eventStart);
              let currentDate = new Date();

              eventStartDate = setTimeToZero(eventStartDate);
              currentDate = setTimeToZero(currentDate);

              return !isUserRole(
                USER_ROLES.ADMIN,
                USER_ROLES.SUPERADMIN,
                USER_ROLES.CLIENT,
                USER_ROLES.COORDINATOR,
              )
                ? eventStartDate >= currentDate
                : true;
            }
          },
        )
        .required('Start time required'),
      eventEnd: Yup.string()
        .test(
          'is-greater-than-or-equal-to-event-start',
          'Event end should be greater than or equal to Event start',
          function (code) {
            if (!this.parent.eventStart || !this.parent.eventEnd) {
              return true;
            }

            let eventStartDate = new Date(this.parent.eventStart);
            let eventEndate = new Date(this.parent.eventEnd);

            eventStartDate = setTimeToZero(eventStartDate);
            eventEndate = setTimeToZero(eventEndate);

            return eventEndate >= eventStartDate;
          },
        )
        .required('End time required'),
      // eventEndGreaterThanOrEqualToEventStart: Yup.boolean()
      //     .test('is-greater-than-or-equal-to-event-start', "Event end should be greater than or equal to Event start", function(code) {
      //         const eventStartDate = new Date(this.parent.eventStart);
      //         const eventEndate = new Date(this.parent.eventEnd);

      //         return (eventEndate >= eventStartDate);
      //     }),
      venue: Yup.string()
        .trim()
        .max(255, 'Venue should have at most 255 characters!')
        .required('Venue required'),
      coordinatorRequestNote: Yup.string().trim().max(2000).optional(),
      contractorRequestNote: Yup.string().trim().max(2000).optional(),
      // poNumber: Yup.string().trim(),
      venueAddressLine1: Yup.string()
        .trim()
        .max(255, 'Address line 1 should have at most 255 characters!')
        .required('Address line 1 required'),
      venueAddressLine2: Yup.string()
        .trim()
        .max(255, 'Address line 2 should have at most 255 characters!')
        .optional(),
      venueCity: Yup.string()
        .trim()
        .max(80, 'City should have at most 80 characters!')
        .required('City required'),
      venueState: Yup.string()
        .trim()
        .max(80, 'State should have at most 80 characters!')
        .required('State required'),
      venueZipCode: Yup.string()
        .trim()
        .max(15, 'Zip code should have at most 15 characters!')
        .required('Zip code required'),
      location: Yup.object().shape({
        latitude: Yup.string().trim(),
        longitude: Yup.string().trim(),
      }),
    });
  }, [eventData]);

  let initialValue = {
    eventName: '',
    eventStart: '',
    eventEnd: '',
    venue: '',
    coordinatorRequestNote: '',
    contractorRequestNote: '',
    // poNumber: "",
    venueAddressLine1: '',
    venueAddressLine2: '',
    venueCity: '',
    venueState: '',
    venueZipCode: '',
    location: {
      latitude: '',
      longitude: '',
    },
  };

  React.useEffect(() => {
    if (eventData) {
      const initialValue = {
        eventName: eventData.eventName,
        eventStart: eventData.eventStart,
        eventEnd: eventData.eventEnd,
        venue: eventData.venue,
        coordinatorRequestNote: eventData.coordinatorRequestNote || '',
        contractorRequestNote: eventData.contractorRequestNote || '',
        poNumber: eventData.poNumber,
        venueAddressLine1: eventData.venueAddressLine1,
        venueAddressLine2: eventData.venueAddressLine2,
        venueCity: eventData.venueCity,
        venueState: eventData.venueState,
        venueZipCode: eventData.venueZipCode,
        location: eventData?.location,
      };
      setValues(initialValue);
      setOldData(initialValue);
    }
  }, [eventData]);

  const saveEvent = React.useCallback(
    (values, eventUpdateEmailRecipients = []) => {
      dispatch(
        updateEventInfomationAction({
          payload: {
            data: {
              ...values,
              eventUpdateEmailRecipients,
            },
            eventId: eventData?._id,
          },
          successCallback: () => {
            // window.location.reload();
            // NOTE: check if the estimate has already generated
            if (eventData?.isEstimateGenerated) {
              dispatch(
                eventEditedAfterEstimateAction({
                  eventId: eventData?._id,
                  data: {
                    isEventEditedAfterEstimate: true,
                  },
                }),
              );
            }
            dispatch(
              alertDialogAciton({
                open: true,
                title: 'Success',
                message: 'Event updated successfully',
              }),
            );

            let previousValues = {};
            let updatedValues = {};
            for (const key in oldData) {
              if (oldData[key] !== values[key]) {
                previousValues[key] = oldData[key];
                updatedValues[key] = values[key];
              }
            }
            dispatch(
              addEditLogAction({
                id: eventData?._id,
                payload: {
                  actionById: userId,
                  eventId: eventData?._id,
                  description: `Event Information updated of event ${values?.eventName}`,
                  previousValues: previousValues,
                  updatedValues: updatedValues,
                },
              }),
            );
            updateEvent();
            handleClose();
          },
          failureCallback: ({ message }) => {
            dispatch(
              alertDialogAciton({
                open: true,
                title: 'Error',
                message: message || 'Something went wrong. Please try again.',
              }),
            );
          },
        }),
      );
    },
    [dispatch, eventData, handleClose, oldData, updateEvent, userId],
  );

  const formik = useFormik({
    initialValues: initialValue,
    validationSchema: formSchema,
    // Saving never emails the client (Casper, 19/10/2026): the client hears about
    // changes only through "Share Revised Estimate".
    onSubmit: (values) => saveEvent(values),
  });

  const {
    values,
    touched,
    errors,
    handleChange,
    handleBlur,
    setFieldValue,
    handleSubmit,
    setValues,
    submitForm,
  } = formik;

  const setAddress = (address) => {
    let zipCode = '',
      state = '',
      city = '',
      premise = '',
      subpremise = '',
      street_number = '',
      route = '',
      neighborhood = '',
      sublocality = '',
      line2 = '',
      line1 = '';
    for (let i = 0; i < address?.address_components?.length; i++) {
      if (address?.address_components?.[i]?.types?.includes('premise')) {
        premise = address?.address_components?.[i]?.long_name;
      } else if (address?.address_components?.[i]?.types?.includes('subpremise')) {
        subpremise = address?.address_components?.[i]?.long_name;
      } else if (address?.address_components?.[i]?.types?.includes('street_number')) {
        street_number = address?.address_components?.[i]?.long_name;
      } else if (address?.address_components?.[i]?.types?.includes('route')) {
        route = address?.address_components?.[i]?.long_name;
      } else if (address?.address_components?.[i]?.types?.includes('neighborhood')) {
        neighborhood = address?.address_components?.[i]?.long_name;
      } else if (address?.address_components?.[i]?.types?.includes?.('sublocality')) {
        sublocality = address?.address_components?.[i]?.long_name;
      } else if (address?.address_components?.[i]?.types?.includes('postal_code')) {
        zipCode = address?.address_components?.[i]?.long_name;
      } else if (address?.address_components?.[i]?.types?.includes('administrative_area_level_1')) {
        state =
          address?.address_components?.[i]?.short_name ||
          address?.address_components?.[i]?.long_name;
      } else if (address?.address_components?.[i]?.types?.includes('locality')) {
        city = address?.address_components?.[i]?.long_name;
      }
    }

    line1 = `${premise ? premise + ', ' : ''}${subpremise ? subpremise + ', ' : ''}${street_number ? street_number + ' ' : ''}${route ? route : ''}`;
    line2 = `${neighborhood ? neighborhood + ', ' : ''}${sublocality ? sublocality : ''}`;

    if (!city) {
      city = state;
    }

    setFieldValue('venueZipCode', zipCode);
    setFieldValue('venueState', state);
    setFieldValue('venueCity', city);
    if (line1) {
      setFieldValue('venueAddressLine1', line1);
    }
    setFieldValue('venueAddressLine2', line2);
    setFieldValue('location', {
      latitude: address?.geometry?.location?.lat(),
      longitude: address?.geometry?.location?.lng(),
    });
    // setFormData({
    //     ...formData,
    //     addressLine1: address,
    // });
  };

  return (
    // <LoadScript googleMapsApiKey={import.meta.env.VITE_GOOGLE_API_KEY} libraries={libraries}>
    // </LoadScript>
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box
        className={styles['dataBox']}
        sx={{
          border: 'none',
          '@media (max-width: 600px)': {
            padding: '15px',
          },
        }}
      >
        {/* <Typography className={styles["createEventTitle"]}> */}
        {/*   Event Information */}
        {/* </Typography> */}
        <Box className={styles['formDataBox']}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Box className={styles['form-box']}>
                <InputLabel>Event Name</InputLabel>
                <CustomInput
                  fullWidth
                  placeholder="Type here..."
                  name="eventName"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.eventName}
                />
                {touched.eventName && errors.eventName && (
                  <span className={styles.error}>{errors.eventName}</span>
                )}
              </Box>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Box className={styles['form-box']}>
                <InputLabel>Event Start</InputLabel>
                <Box className={styles['input-icon-box icon-end']}>
                  <CustomDatePicker
                    name="eventStart"
                    // slotProps={{
                    //   textField: {
                    //     onKeyDown: (e) => {
                    //       e.preventDefault();
                    //     },
                    //   },
                    // }}
                    onChange={(date) => {
                      if (date === null) {
                        setFieldValue('eventStart', null);
                      } else if (date?.isValid()) {
                        setFieldValue('eventStart', date.format('YYYY-MM-DD'));
                      }
                    }}
                    value={values.eventStart ? dayjs(values.eventStart) : null}
                    onBlur={handleBlur}
                    // format={values.eventStart ? "ddd MM/DD/YYYY" : "MM/DD/YYYY"}
                    disablePast={
                      isUserRole(
                        USER_ROLES.CLIENT,
                        USER_ROLES.COORDINATOR,
                        USER_ROLES.ADMIN,
                        USER_ROLES.SUPERADMIN,
                      )
                        ? false
                        : true
                    }
                  />
                  {touched.eventStart && errors.eventStart && (
                    <span className={styles.error}>{errors.eventStart}</span>
                  )}
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Box className={styles['form-box']}>
                <InputLabel>Event End</InputLabel>
                <Box className={styles['input-icon-box icon-end']}>
                  <CustomDatePicker
                    minDate={dayjs(values?.eventStart || new Date())}
                    name="eventEnd"
                    onChange={(date) => {
                      if (date === null) {
                        setFieldValue('eventEnd', null);
                      } else if (date?.isValid()) {
                        setFieldValue('eventEnd', date.format('YYYY-MM-DD'));
                      }
                    }}
                    value={values.eventEnd ? dayjs(values.eventEnd) : null}
                    onBlur={handleBlur}
                    // format={values.eventEnd ? "ddd MM/DD/YYYY" : "MM/DD/YYYY"}
                  />
                  {touched.eventEnd && errors.eventEnd ? (
                    <span className={styles.error}>{errors.eventEnd}</span>
                  ) : null}
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box className={styles['form-box']}>
                <InputLabel>Venue</InputLabel>
                <CustomInput
                  fullWidth
                  placeholder="Type here..."
                  name="venue"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.venue}
                />
                {touched.venue && errors.venue && (
                  <span className={styles.error}>{errors.venue}</span>
                )}
              </Box>
            </Grid>
            {/* <Grid item xs={12} sm={6}> */}
            {/*   <Box className={styles["form-box"]}> */}
            {/*     <InputLabel>PO Number</InputLabel> */}
            {/*     <CustomInput */}
            {/*       fullWidth */}
            {/*       placeholder="Optional" */}
            {/*       name="poNumber" */}
            {/*       onChange={handleChange} */}
            {/*       onBlur={handleBlur} */}
            {/*       value={values.poNumber} */}
            {/*     /> */}
            {/*     {touched.poNumber && errors.poNumber && ( */}
            {/*       <span className={styles.error}>{errors.poNumber}</span> */}
            {/*     )} */}
            {/*   </Box> */}
            {/* </Grid> */}
            <Grid item xs={12}>
              <TextField
                className={styles.requestNoteField}
                fullWidth multiline minRows={3}
                label="Note for coordinator (optional)"
                helperText="Internal instructions for the ShowPhaze coordinator."
                name="coordinatorRequestNote"
                inputProps={{ maxLength: 2000 }}
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.coordinatorRequestNote || ''}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                className={styles.requestNoteField}
                fullWidth multiline minRows={3}
                label="Note for contractor / SOW (optional)"
                helperText="This instruction will appear on the contractor's Scope of Work."
                name="contractorRequestNote"
                inputProps={{ maxLength: 2000 }}
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.contractorRequestNote || ''}
              />
            </Grid>
            <Grid item xs={12}>
              <Box className={styles['form-box']}>
                <InputLabel>Venue Address Line 1</InputLabel>
                {/* {googleMapsPackage?.isLoaded ? ( */}
                <AddressAutocomplete
                  setAddress={setAddress}
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  libraries={libraries}
                  value={values.venueAddressLine1}
                  name="venueAddressLine1"
                  fullWidth
                  placeholder="Type here..."
                  onChange={handleChange}
                />
                {/* ) : googleMapsPackage?.loadError ? (
                  <CustomInput
                    fullWidth
                    placeholder="Type here..."
                    name="venueAddressLine1"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.venueAddressLine1}
                  />
                ) : null} */}
                {/* <CustomInput
                    fullWidth
                    placeholder="Type here..."
                    name="venueAddressLine1"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.venueAddressLine1}
                  /> */}
                {touched.venueAddressLine1 && errors.venueAddressLine1 && (
                  <span className={styles.error}>{errors.venueAddressLine1}</span>
                )}
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box className={styles['form-box']}>
                <InputLabel>Venue Address Line 2</InputLabel>
                <CustomInput
                  fullWidth
                  placeholder="Type here..."
                  name="venueAddressLine2"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.venueAddressLine2}
                />
                {touched.venueAddressLine2 && errors.venueAddressLine2 && (
                  <span className={styles.error}>{errors.venueAddressLine2}</span>
                )}
              </Box>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Box className={styles['form-box']}>
                <InputLabel>Venue City</InputLabel>
                <CustomInput
                  fullWidth
                  placeholder="Type here..."
                  name="venueCity"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.venueCity}
                />
                {touched.venueCity && errors.venueCity && (
                  <span className={styles.error}>{errors.venueCity}</span>
                )}
              </Box>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Box className={styles['form-box']}>
                <InputLabel>Venue State</InputLabel>
                <CustomInput
                  fullWidth
                  placeholder="Type here..."
                  name="venueState"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.venueState}
                />
                {touched.venueState && errors.venueState && (
                  <span className={styles.error}>{errors.venueState}</span>
                )}
              </Box>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Box className={styles['form-box']}>
                <InputLabel>Venue Zip Code</InputLabel>
                <CustomInput
                  fullWidth
                  placeholder="Type here..."
                  name="venueZipCode"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.venueZipCode}
                />
                {touched.venueZipCode && errors.venueZipCode && (
                  <span className={styles.error}>{errors.venueZipCode}</span>
                )}
              </Box>
            </Grid>
          </Grid>
        </Box>

        <Box className="bottom-btn-box">
          <Button
            className="btn-black"
            onClick={() => {
              formik.setValues(initialValue);
              handleClose();
            }}
          >
            <Typography className="btn-text">CLOSE</Typography>
          </Button>
          <Button
            sx={{
              cursor: ucLoading ? 'not-allowed' : 'pointer',
            }}
            disableRipple={ucLoading}
            className="btn-pink"
            onClick={() => {
              if (ucLoading) return;
              submitForm();
            }}
          >
            {ucLoading ? (
              <CircularProgress />
            ) : (
              <Typography className="btn-text">Submit</Typography>
            )}
          </Button>
        </Box>

      </Box>
    </LocalizationProvider>
  );
}

EditEventTab.propTypes = {
  eventData: PropTypes.object,
  handleClose: PropTypes.func,
  updateEvent: PropTypes.func,
};
